import { render } from "./ProtectionCover.vue?vue&type=template&id=596093d2&scoped=true"
import script from "./ProtectionCover.vue?vue&type=script&lang=js"
export * from "./ProtectionCover.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-596093d2"

export default script